import { render, staticRenderFns } from "./CustomerPreview.vue?vue&type=template&id=1455a768&scoped=true"
import script from "./CustomerPreview.vue?vue&type=script&lang=ts"
export * from "./CustomerPreview.vue?vue&type=script&lang=ts"
import style0 from "./CustomerPreview.vue?vue&type=style&index=0&id=1455a768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1455a768",
  null
  
)

export default component.exports